<template>
    <div>
        <b-modal
            id="archive-popup"
            ref="modal"
            size="sm"
            :title="title"
            no-close-on-backdrop
            modal-class="hide-footer ds"
            no-close-on-esc
            :hide-header-close="loading"
            hide-footer
            @hidden="onHidden"
        >
            <!--  <div slot="modal-header" class="w-100 archive-popup">
                <h5 class="modal-title">{{ title }}</h5>
                {{ loading }}
            </div> -->
            <p class="custom-model-form custom-risk-override">
                {{ description }}
            </p>
            <div class="col-md-12 action-buttons">
                <button
                    :class="['btn btn-primary', { disabled: loading }]"
                    type="submit"
                    @click="$emit('update-status', 'archived')"
                >
                    <span class="btn-text">Archive</span>
                    <span class="loader"></span>
                </button>
                <button
                    class="btn btn-link"
                    type="button"
                    :disabled="loading"
                    @click="onHidden"
                >
                    <span class="btn-text">Cancel</span>
                </button>
            </div>
            <base-toast></base-toast>
        </b-modal>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {
    props: {
        recordType: {
            type: String,
        },
    }, //
    watch: {
        hidePopup(val) {
            if (val) {
                this.onHidden()
            }
        },
    },
    computed: {
        ...mapGetters(['loading', 'hidePopup']),
        title() {
            return 'Archive ' + _.startCase(this.recordType)
        },
        description() {
            return (
                'Are you sure you want to archive this ' +
                _.lowerCase(this.recordType) +
                '? You can re-activate it later.'
            )
        },
    },
    data() {
        return {}
    },
    methods: {
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
    },
}
</script>
